export default __webpack_public_path__ + "static/heroSectionBg-ac3b0ba4b2fdb6a44dc528e0a42be4ff.png";